import { Text } from "@chakra-ui/react";
import React from "react";

const PrimaryText = (props) => {
  return <Text fontWeight="bold" color="primary.1" {...props} />;
};

export default PrimaryText;
